<template>
  <div>
    <div v-for="(story, story_i) in stories" :key="`story_${story_i}`" class="columns my-2 is-multiline">
      <div class="column is-6">
        <div class="card">
          <div class="card-image">
            <figure class="image">
              <show-image :src="story.picture_library.file" />
            </figure>
          </div>
          <div class="card-content">
            <p class="title is-4"><span class="hover-allow" style="float:left;margin-right: 24px;" @click="$common.readQuestionLoud(story.text)"><b-icon icon="volume-high"></b-icon></span>{{story.text}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ShowImage from '@/components/General/ShowImage'
export default {
  props : {
    stories : Array
  },
  components : {
    ShowImage
  }
}
</script>